import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { getTokenFromLocalStorage } from './apiClient';
import { adminNotificationAPI } from '../services/adminNotification';

// Thông báo đẩy của app iOS On Admin (vỏ Capacitor nạp admin.on-coffee.com). Trình duyệt thường: không làm gì.
const TOKEN_CACHE = 'admin-push-device-token';
let deviceToken;
let initialized;

export const isAdminNative = () => Capacitor.isNativePlatform();

export async function bindPushDevice() {
  if (!deviceToken || !getTokenFromLocalStorage()) return;
  await adminNotificationAPI.registerDevice(deviceToken, Capacitor.getPlatform());
}

export async function initializeNativeNotifications() {
  if (!isAdminNative()) return;
  if (!initialized)
    initialized = (async () => {
      await PushNotifications.addListener('registration', ({ value }) => {
        deviceToken = value;
        try {
          localStorage.setItem(TOKEN_CACHE, value);
        } catch {
          // Bộ nhớ trình duyệt bị khoá: bỏ qua.
        }
        bindPushDevice().catch(() => {});
      });
      await PushNotifications.addListener('pushNotificationReceived', () =>
        window.dispatchEvent(new CustomEvent('admin:notification')),
      );
      await PushNotifications.addListener('pushNotificationActionPerformed', () =>
        window.location.assign('/notification'),
      );
    })().catch((error) => {
      initialized = undefined;
      throw error;
    });
  await initialized;
}

export async function pushPermission() {
  if (!isAdminNative()) return 'unsupported';
  return (await PushNotifications.checkPermissions()).receive;
}

/** Đã cho phép từ trước thì đăng ký lại lặng lẽ mỗi lần mở app (token APNs có thể đổi). */
export async function restoreNativeNotifications() {
  if (!isAdminNative()) return;
  await initializeNativeNotifications();
  if ((await pushPermission()) === 'granted') await PushNotifications.register();
}

export async function enableNativeNotifications() {
  await initializeNativeNotifications();
  let permission = await pushPermission();
  if (permission === 'prompt' || permission === 'prompt-with-rationale')
    permission = (await PushNotifications.requestPermissions()).receive;
  if (permission !== 'granted') return false;
  await PushNotifications.register();
  return true;
}

/** Gọi TRƯỚC khi xoá token đăng nhập: máy dùng chung không nhận tiếp tin của tài khoản cũ. */
export function releasePushDevice() {
  if (!isAdminNative()) return;
  let token = deviceToken;
  try {
    token = token || localStorage.getItem(TOKEN_CACHE);
    localStorage.removeItem(TOKEN_CACHE);
  } catch {
    // Bộ nhớ trình duyệt bị khoá: bỏ qua.
  }
  const accessToken = getTokenFromLocalStorage();
  deviceToken = undefined;
  if (token && accessToken) adminNotificationAPI.unregisterDevice(token, accessToken).catch(() => {});
  PushNotifications.removeAllDeliveredNotifications().catch(() => {});
}
